import { useEffect, useRef, useState } from "react";

/**
 * useApiData(fetcherFn, params, { skip, deps })
 * - fetcherFn: fonction (params) => Promise<data>, ex: api.getEau
 * - params: objet passé au fetcher (doit être stable/sérialisable)
 * - skip: si true, ne fetch pas (ex: tant que les filtres ne sont pas prêts)
 *
 * Annule proprement les requêtes obsolètes si les params changent vite
 * (l'utilisateur qui manipule un slider par ex.).
 */
export function useApiData(fetcherFn, params, { skip = false } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(null);
  const requestId = useRef(0);

  const key = JSON.stringify(params);

  useEffect(() => {
    if (skip) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    const id = ++requestId.current;
    setLoading(true);
    setError(null);

    fetcherFn(params)
      .then((result) => {
        if (cancelled || id !== requestId.current) return;
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled || id !== requestId.current) return;
        setError(
          err?.response?.data?.message || err.message || "Erreur inconnue"
        );
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, skip]);

  return { data, loading, error };
}
